import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChatConversationListScreenComponent } from './fi-chat-conversation-list-screen/fi-chat-conversation-list-screen.component';
import { FiChatConversationListContainerComponent } from './fi-chat-conversation-list-container/fi-chat-conversation-list-container.component';
import { FiChatConversationListComponent } from './fi-chat-conversation-list/fi-chat-conversation-list.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiChatConversationListItemComponent } from './fi-chat-conversation-list-item/fi-chat-conversation-list-item.component';
import { FicScreenModule } from '@fi-shared/fic-screen/fic-screen.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiChatConversationSearchComponent } from './fi-chat-conversation-search/fi-chat-conversation-search.component';
import { FiChatConversationImageModule } from '@fi-shared/fi-chat/fi-chat-conversation-image/fi-chat-conversation-image.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { FiChatConversationSuggestionItemComponent } from './fi-chat-conversation-suggestion-item/fi-chat-conversation-suggestion-item.component';
import { FiChatConversationUsersListModule } from '@fi-shared/fi-chat/fi-chat-conversation-users-list/fi-chat-conversation-users-list.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiLongPressMobileModule } from '@fi-shared/fi-directives/fi-long-press/fi-long-press-mobile.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        FiAppTextSharedModule,
        MatButtonModule,
        MatIconModule,
        FicScreenModule,
        FiFormatDateModule,
        FiChatConversationImageModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        FiChatConversationUsersListModule,
        MatMenuModule,
        FiLongPressMobileModule,
        FiLoadingModule,
        FiWhenScrolledModule,
        FiLineClampModule,
    ],
    declarations: [
        FiChatConversationListScreenComponent,
        FiChatConversationListContainerComponent,
        FiChatConversationListComponent,
        FiChatConversationListItemComponent,
        FiChatConversationSearchComponent,
        FiChatConversationSuggestionItemComponent,
    ],
    exports: [FiChatConversationListContainerComponent],
})
export class FiChatConversationListModule {}
